module.exports = __webpack_public_path__ + "img/emoji.2ac0deda.svg";